import { useTheme } from '@approvalmax/theme';
import { Box, Divider, Flex, Grid } from '@approvalmax/ui/src/components';
import random from 'lodash/random';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMedia } from 'react-use';

import { Main } from './resources/styles';

export const Loading = memo(() => {
    const { theme } = useTheme();
    const xsmallViewport = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);

    return (
        <Grid gridTemplateRows='max-content 1fr' height='100%'>
            <Flex
                alignItems={xsmallViewport ? 'start' : 'center'}
                direction={xsmallViewport ? 'column' : 'row'}
                spacing={xsmallViewport ? '4' : '16'}
                wrap={false}
            >
                <Skeleton width={300} height={12} />
            </Flex>

            <Main>
                <Box spacing={xsmallViewport ? '24 0' : '16 24 0 0'}>
                    <Flex direction='column'>
                        {range(10).map((index) => (
                            <Skeleton key={index} width={random(100, xsmallViewport ? 280 : 500)} />
                        ))}
                    </Flex>
                </Box>

                <Divider orientation='vertical' spacing={`0 0 ${xsmallViewport ? '-24' : '-40'}`} />

                <Box spacing={xsmallViewport ? '0' : '16 0 0 24'}>
                    <Flex direction='column'>
                        <Skeleton width={100} height={24} />

                        {range(10).map((index) => (
                            <Skeleton key={index} width='100%' height={40} />
                        ))}
                    </Flex>
                </Box>
            </Main>
        </Grid>
    );
});

Loading.displayName = 'Loading';
